import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TSmsApi } from './types';

export const sms: TSmsApi = {
	getSmsList: (payload) =>
		http.post(endpoint.sms.LIST, payload).then((response) => response.data),
	getSmsTypes: () => http.get(endpoint.sms.TYPES).then((response) => response.data),
	sendSms: (payload) => http.post(endpoint.sms.SEND, payload).then((response) => response.data),
};
